/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BacksolveBulkRead } from './BacksolveBulkRead';
export type Allocation = {
  readonly id?: number;
  readonly status?: Allocation.status;
  is_firm_owned: boolean | null;
  is_ready_for_audit: boolean | null;
  readonly valuation_id?: number;
  name: string;
  version?: number;
  readonly market_date?: string;
  readonly backsolves?: Array<BacksolveBulkRead>;
};
export namespace Allocation {
  export enum status {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    FINAL = 'FINAL',
  }
}
